import { classNames } from '../../utils/dom'

export const labelClasses = error => classNames(['label', 'is-required', error ? 'has-error' : ''])

export default labelClasses
